import Avatar from 'components/base/Avatar';
import { useMemo } from 'react';
import { Card, Dropdown, Form, Nav } from 'react-bootstrap';
import avatar from 'assets/img/team/72x72/57.webp';
import FeatherIcon from 'feather-icons-react';
import { Link } from 'react-router-dom';
import Scrollbar from 'components/base/Scrollbar';
import classNames from 'classnames';
import { useAuth } from 'providers/AuthProvider';
import { useTranslation } from 'react-i18next';

const ProfileDropdownMenu = ({ className }: { className?: string }) => {
  const { user } = useAuth();
  const { t } = useTranslation();
  const tt = (key: string, options?: Record<string, unknown>) =>
    t(key, { ns: 'translation', ...options });

  const navItems = useMemo(
    () => [
      {
        label: tt('nav.profileDropdown.items.profile'),
        icon: 'user'
      },
      {
        label: tt('nav.profileDropdown.items.dashboard'),
        icon: 'pie-chart'
      },
      {
        label: tt('nav.profileDropdown.items.helpCenter'),
        icon: 'help-circle'
      },
      {
        label: tt('nav.profileDropdown.items.language'),
        icon: 'globe'
      }
    ],
    [t]
  );
  return (
    <Dropdown.Menu
      align="end"
      className={classNames(
        className,
        'navbar-top-dropdown-menu navbar-dropdown-caret py-0 dropdown-profile shadow border'
      )}
    >
      <Card className="position-relative border-0">
        <Card.Body className="p-0">
          <div className="d-flex flex-column align-items-center justify-content-center gap-2 pt-4 pb-3">
            <Avatar src={avatar} size="xl" />
            <h6 className="text-body-emphasis">{user?.name || tt('nav.profileDropdown.userFallback')}</h6>
          </div>
          <div className="mb-3 mx-3">
            <Form.Control
              type="text"
              placeholder={tt('nav.profileDropdown.updateStatusPlaceholder')}
              size="sm"
            />
          </div>
          <div style={{ height: '10rem' }}>
            <Scrollbar>
              <Nav className="nav flex-column mb-2 pb-1">
                {navItems.map(item => (
                  <Nav.Item key={item.label}>
                    <Nav.Link href="#!" className="px-3">
                      <FeatherIcon
                        icon={item.icon}
                        size={16}
                        className="me-2 text-body"
                      />
                      <span className="text-body-highlight">{item.label}</span>
                    </Nav.Link>
                  </Nav.Item>
                ))}
              </Nav>
            </Scrollbar>
          </div>
        </Card.Body>
        <Card.Footer className="p-0 border-top border-translucent">
          {/* <Nav className="nav flex-column my-3">
            <Nav.Item>
              <Nav.Link href="#!" className="px-3">
                <FeatherIcon
                  icon="user-plus"
                  size={16}
                  className="me-2 text-body"
                />
                <span>Add another account</span>
              </Nav.Link>
            </Nav.Item>
          </Nav> */}
          <br />
          <div className="px-3">
            <Link
              to="/auth/logout"
              className="btn btn-phoenix-secondary d-flex flex-center w-100"
            >
              <FeatherIcon icon="log-out" className="me-2" size={16} />
              {tt('nav.profileDropdown.signOut')}
            </Link>
          </div>
          <div className="my-2 text-center fw-bold fs-10 text-body-quaternary">
            <Link className="text-body-quaternary me-1" to="#!">
              {tt('nav.profileDropdown.footer.privacyPolicy')}
            </Link>
            •
            <Link className="text-body-quaternary mx-1" to="#!">
              {tt('nav.profileDropdown.footer.terms')}
            </Link>
            •
            <Link className="text-body-quaternary ms-1" to="#!">
              {tt('nav.profileDropdown.footer.cookies')}
            </Link>
          </div>
        </Card.Footer>
      </Card>
    </Dropdown.Menu>
  );
};

export default ProfileDropdownMenu;
